module.exports = __webpack_public_path__ + "img/biaoqian_gaocengjianzhu.5723fd0e.png";